import { existsSync } from 'node:fs';
import { resolve } from 'node:path';
import { build as bunBuild } from 'bun';
import { sendTelemetryEvent } from '../cli/telemetryEvent';

const resolveHmrClientPath = () => {
	const projectRoot = process.cwd();
	const fromSource = resolve(import.meta.dir, 'client/hmrClient.ts');

	if (existsSync(fromSource) && fromSource.startsWith(projectRoot)) {
		return fromSource;
	}

	const fromNodeModules = resolve(
		projectRoot,
		'node_modules/@absolutejs/absolute/dist/dev/client/hmrClient.ts'
	);
	if (existsSync(fromNodeModules)) return fromNodeModules;

	return resolve(import.meta.dir, 'dev/client/hmrClient.ts');
};

const hmrClientPath = resolveHmrClientPath();

export const buildHMRClient = async () => {
	const entryPoint = hmrClientPath;
	const result = await bunBuild({
		entrypoints: [entryPoint],
		format: 'iife',
		minify: false,
		target: 'browser'
	});
	if (!result.success) {
		console.error('Failed to build HMR client:', result.logs);
		sendTelemetryEvent('hmr:client-build-failed', {
			logCount: result.logs.length,
			message: result.logs.map((log) => log.message).join('; ')
		});

		return '// HMR client build failed';
	}

	const [firstOutput] = result.outputs;
	if (!firstOutput) return '// HMR client build failed';

	return firstOutput.text();
};
